var map = {
	"./flags/china.svg": 691,
	"./flags/czech.svg": 692,
	"./flags/france.svg": 693,
	"./flags/germany.svg": 694,
	"./flags/japan.svg": 695,
	"./flags/notFound.svg": 476,
	"./flags/poland.svg": 696,
	"./flags/russia.svg": 697,
	"./flags/swiss.svg": 698,
	"./flags/usa.svg": 699
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 690;